import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Row,
  Select,
  Spin,
  Table,
  Typography,
  message,
} from "antd";
import { Footer } from "antd/lib/layout/layout";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import { LanguageContext } from "../../context/LanguageContext";
import { professionalAction } from "../../_actions";
import { adminServiceAction } from "../../_actions/admin.service";

const { Title } = Typography;
const { Option } = Select;

class AropiCount extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
    this.state = {
      loading: false,
      rows: [],
      years: [],
      download: "excel",
      startYear: moment().startOf("year"),
      endYear: moment().startOf("year"),
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
      },
    };
  }

  componentDidMount() {
    this.props.dispatch(professionalAction.getCity());
    this.loadData();
  }

  getCityName = (id) => {
    const pc_cities = this.props.professionals?.pc_cities;
    if (!pc_cities || !pc_cities.length) {
      return "";
    }
    const city = pc_cities.find((item) => item.id === id);
    return city?.City || "";
  };

  handleTableChange = (pagination) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        ...pagination,
      },
    });
  };

  onStartYearChange = (value) => {
    const { endYear } = this.state;
    const nextEndYear =
      value && endYear && value.year() > endYear.year() ? value : endYear;
    this.setState({ startYear: value, endYear: nextEndYear });
  };

  onEndYearChange = (value) => {
    this.setState({ endYear: value });
  };

  loadData = () => {
    const { startYear, endYear } = this.state;
    const city = this.props.user?.cityId;

    if (!city) {
      message.warning("City is not available for this user");
      return;
    }

    if (!startYear || !endYear) {
      message.warning("Select start year and end year");
      return;
    }

    const startYearValue = startYear.year();
    const endYearValue = endYear.year();

    if (startYearValue > endYearValue) {
      message.warning("Start year must be before end year");
      return;
    }

    this.setState({ loading: true });
    adminServiceAction
      .aropiCountYear({
        city,
        startYear: startYearValue,
        endYear: endYearValue,
      })
      .then((res) => (res && res.json ? res.json() : res))
      .then((resp) => {
        if (!resp || resp.status !== 200) {
          message.error(resp?.message || "Unable to load accused count");
          this.setState({
            loading: false,
            rows: [],
            years: [],
            pagination: { ...this.state.pagination, current: 1 },
          });
          return;
        }
        this.setState({
          loading: false,
          rows: Array.isArray(resp.data) ? resp.data : [],
          years: Array.isArray(resp.years) ? resp.years : [],
          pagination: { ...this.state.pagination, current: 1 },
        });
      })
      .catch(() => {
        message.error("Unable to load accused count");
        this.setState({ loading: false });
      });
  };

  downloadReport = () => {
    const { t } = this.context;
    const { rows, years, startYear, endYear } = this.state;

    if (!rows || !rows.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const reportTitle = "आरोपी संख्या";
    const fileName = `Aropi_Count_${moment().format("DDMMMYYYY")}`;
    const startYearText = startYear?.format("YYYY") || "";
    const endYearText = endYear?.format("YYYY") || "";
    const yearHeaders = (years || []).map((year) => String(year));
    const headers = ["अ.क्र.", "पोलिस ठाणे", ...yearHeaders, "एकुण"];
    const arrData = rows.map((item, index) => {
      const row = {
        "अ.क्र.": index + 1,
        "पोलिस ठाणे": item.district || "-",
        एकुण: Number(item.Total || 0),
      };
      yearHeaders.forEach((year) => {
        row[year] = Number(item[year] || 0);
      });
      return row;
    });

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };
    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const totalCols = headers.length;
    const cityName = this.getCityName(this.props.user?.cityId) || "";

    XLSX.utils.sheet_add_aoa(ws, [[cityName]], { origin: "A1" });
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(
      ws,
      [[`${reportTitle}  From : ${startYearText} to : ${endYearText}`]],
      { origin: "A2" },
    );
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });
    headers.forEach((_, columnIndex) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c: columnIndex });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    const sheetRows = arrData.map((row) => headers.map((key) => row[key]));
    XLSX.utils.sheet_add_aoa(ws, sheetRows, { origin: "A4" });
    sheetRows.forEach((row, rowIndex) => {
      row.forEach((_, columnIndex) => {
        const cell = XLSX.utils.encode_cell({
          r: rowIndex + 3,
          c: columnIndex,
        });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    const footerRowIndex = sheetRows.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;
    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", wrapText: true },
    };
    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] ?? "").length),
        ) + 6,
    }));
    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 42 }];
    for (let i = 3; i < sheetRows.length + 3; i += 1) {
      ws["!rows"][i] = { hpt: 28 };
    }
    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };
    ws["!merges"] = merges;

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  getColumns = () => {
    const { pagination } = this.state;
    const yearColumns = (this.state.years || []).map((year) => ({
      title: String(year),
      dataIndex: String(year),
      key: String(year),
      align: "center",
      render: (value) => value ?? 0,
    }));

    return [
      {
        title: "अ.क्र.",
        key: "index",
        width: 80,
        render: (_, __, rowIndex) =>
          (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
      },
      {
        title: "पोलिस ठाणे",
        dataIndex: "district",
        key: "district",
      },
      ...yearColumns,
      {
        title: "एकुण",
        dataIndex: "Total",
        key: "Total",
        align: "center",
        render: (value) => value ?? 0,
      },
    ].map((col) => ({
      ...col,
      title: <span style={{ fontSize: "18px" }}>{col.title}</span>,
    }));
  };

  render() {
    const { t } = this.context;
    const { loading, rows, startYear, endYear, pagination, download } =
      this.state;
    const cityName = this.getCityName(this.props.user?.cityId);
    const total = (rows || []).reduce(
      (sum, row) => sum + Number(row.Total || 0),
      0,
    );
    const dataSource = (rows || []).map((item, index) => ({
      key: item.districtId ?? index,
      ...item,
    }));

    return (
      <Spin spinning={loading} delay={500}>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <div
              style={{
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                alignItems: "center",
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 500 }}>Start Year</span>
              <DatePicker
                picker="year"
                value={startYear}
                allowClear={false}
                placeholder="Start Year"
                onChange={this.onStartYearChange}
                style={{ minWidth: 140 }}
              />
              <span style={{ fontSize: 14, fontWeight: 500 }}>End Year</span>
              <DatePicker
                picker="year"
                value={endYear}
                allowClear={false}
                placeholder="End Year"
                onChange={this.onEndYearChange}
                style={{ minWidth: 140 }}
                disabledDate={(current) =>
                  current && startYear && current.year() < startYear.year()
                }
              />
              <Button type="primary" loading={loading} onClick={this.loadData}>
                {t("find")}
              </Button>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "6px 14px",
                  background: "#6f42c1",
                  borderRadius: 6,
                  boxShadow: "0 2px 6px rgba(111, 66, 193, 0.25)",
                }}
              >
                <span style={{ fontSize: 13, color: "#fff" }}>
                  {t("total")}:
                </span>
                <strong style={{ fontSize: 16, color: "#fff" }}>{total}</strong>
              </div>
              <Select
                style={{ width: 120 }}
                value={download}
                onChange={(value) => this.setState({ download: value })}
              >
                <Option value="excel">{t("excel")}</Option>
              </Select>
              <Button
                type="primary"
                disabled={!download || !rows.length}
                onClick={this.downloadReport}
              >
                {t("download")}
              </Button>
            </div>
            <div ref={this.myTableRef}>
              <Card>
                <Row
                  justify="center"
                  align="middle"
                  style={{ marginBottom: 16, textAlign: "center" }}
                >
                  <Col>
                    <Title level={3} style={{ fontSize: "24px" }}>
                      आरोपी संख्या - {cityName}
                    </Title>
                    {startYear && (
                      <Title
                        level={5}
                        style={{ fontSize: "20px", marginBottom: 8 }}
                      >
                        From : {startYear.format("YYYY")}{" "}
                        {endYear && <>to : {endYear.format("YYYY")}</>}
                      </Title>
                    )}
                    <Title
                      level={5}
                      style={{ fontSize: "20px", marginBottom: 8 }}
                    >
                      एकुण आरोपी:{total}
                    </Title>
                  </Col>
                </Row>
                <Table
                  bordered
                  loading={loading}
                  scroll={{ x: "max-content" }}
                  columns={this.getColumns()}
                  dataSource={dataSource}
                  rowClassName={() => "govt-table-row"}
                  style={{ fontSize: "18px" }}
                  pagination={{
                    ...pagination,
                    total: dataSource.length,
                    showTotal: (count) => `Total ${count}`,
                  }}
                  onChange={this.handleTableChange}
                />
              </Card>
            </div>
          </div>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReports = connect(mapStateToProps)(AropiCount);
export { connectedReports as AropiCount };
